// @flow
import React, { Component } from "react";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import { GeneralModalForm } from "imagus-components";
import CreateLicenceFormRedux from "../containers/licences/CreateLicenceFormRedux";
import CreateUserFormRedux from "../containers/users/CreateUserFormRedux";
import CreateCompanyFormRedux from "../containers/companies/CreateCompanyFormRedux";
import CreateFacebaseFormRedux from "../containers/facebases/CreateFacebaseFormRedux";

type CreateButtonPropsType = {
  iconName: string,
  formName: string,
  title: string,
  theme: "dark" | "light",
  modal: string,
  iconOnly?: boolean,
  className?: string,
  mini?: boolean,
  company: { [key: string]: string },
  facebases?: Array<*>,
  openSnackbar?: Function
};

type CreateButtonStatesType = {
  modalOpen: boolean
};

class CreateButton extends Component<CreateButtonPropsType, CreateButtonStatesType> {
  constructor(props: CreateButtonPropsType){
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  }

  render(): * {
    const icons = {
      NoteAddIcon: NoteAddIcon,
      PersonAddIcon: PersonAddIcon,
      FiberNewIcon: FiberNewIcon,
      GroupWorkIcon: GroupWorkIcon,
      EditIcon: EditIcon,
      DeleteIcon: DeleteIcon
    };
    const IconName = icons[this.props.iconName];

    const forms = {
      CreateLicenceFormRedux: CreateLicenceFormRedux,
      CreateUserFormRedux: CreateUserFormRedux,
      CreateCompanyFormRedux: CreateCompanyFormRedux,
      CreateFacebaseFormRedux: CreateFacebaseFormRedux
    };
    const FormName = forms[this.props.formName];
    return (
      <span>
        <Tooltip disableFocusListener={true} title={this.props.title + " for " + this.props.company.name}>
          <Fab
            variant={this.props.iconOnly ? "round" : "extended"}
            color="primary"
            {...(this.props.iconOnly && this.props.mini ? { mini: true } : {})}
            className={(this.props.theme === "dark" ? "dark-btn" : "light-btn") + (this.props.className ? " " + this.props.className : "")}
            onClick={(): * => this.switchModalStatus(true)}
          >
            <IconName className={(this.props.theme === "dark" ? "light-icon" : "green-icon") + (this.props.iconOnly ? "" : " right-margin-5")} />
            {this.props.iconOnly ? "" : this.props.title}
          </Fab>
        </Tooltip>
        <GeneralModalForm
          title={this.props.title + " for " + this.props.company.name}
          open={this.state.modalOpen}
          handleModalStatus={this.switchModalStatus}
          form={
            <FormName
              onClose={(): * => this.switchModalStatus(false)}
              company={this.props.company}
              facebases={this.props.facebases ? this.props.facebases : undefined}
              openSnackbar={this.props.openSnackbar}
            />
          }
        />
      </span>
    );
  }
}

export default CreateButton;
